import React, { useState } from 'react';
import {
    EditFilled
} from '@ant-design/icons';
import {
    Button,
    Form,
    Input,
    Modal,
    Select,
    Row,
    Col,
    InputNumber,
    Switch,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function EditFormModal({ data, categories, brands }) {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutation({
        mutationFn: ({ values, id }) => {
            axios
                .put(`/api/product/${id}`, values)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => setOpen(false)
                    });
                    queryClient.invalidateQueries(['/api/product/'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });


    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({ values, id: data._id }))
    };

    const onCancelCreate = () => {
        setOpen(false);
    }
    // console.log(data);
    return (
        <div>
            {contextHolder}
            <Button
                type='text'
                icon={<EditFilled />}
                style={{ color: '#5f77fc' }}
                onClick={() => setOpen(true)} />
            <Modal
                open={open}
                title="แก้ไขสินค้า"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name={`edit${data._id}`}
                    initialValues={{ ...data, category: data.category.id, brand: data.brand.id }}
                >
                    <Form.Item
                        name="name"
                        label="รุ่น"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Row gutter={[8, 8]}>
                        <Col xs={12}>
                            <Form.Item
                                label="ประเภท"
                                name="category"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="เลือกประเภทสินค้า"
                                >
                                    {
                                        categories.map(item => <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="แบรนด์"
                                name="brand"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="เลือกแบรนด์สินค้า"
                                >
                                    {
                                        brands.map(item => <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12} md={8}>
                            <Form.Item
                                label="ราคาขายต่ำสุด"
                                name="min_price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} md={8}>
                            <Form.Item
                                label="ราคาปกติ"
                                name="price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} md={8}>
                            <Form.Item
                                label="ราคาขาย"
                                name="selling_price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item
                                name="color"
                                label="สี"
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item name="description" label="รายละเอียด">
                                <Input.TextArea rows={2} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} md={8}>
                            <Form.Item label="สถานะ" name="is_active" valuePropName="checked">
                                <Switch checkedChildren="ขาย" unCheckedChildren="ยกเลิก" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>

    )
}
